import "./cooperation.css";

const Cooperation = () => {
  return (
    <div className="left-side-cooperation">
      <h4>Cooperation</h4>
    </div>
  );
};

export default Cooperation;
